import { render, staticRenderFns } from "./CierreCajaDetalle.vue?vue&type=template&id=31da30bb"
import script from "./CierreCajaDetalle.vue?vue&type=script&lang=ts"
export * from "./CierreCajaDetalle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports